import { Control, Controller, FieldValues, Path } from 'react-hook-form'

import { WidgetBadgeChoice } from '@/common/form/choice'

import Badge, { BadgeType } from '@/components/view/atoms/badge/Badge'
import { DisclosureSize } from '@/components/view/layouts/disclosure/Disclosure'
import DisclosureSelector from '@/components/view/molecules/selector/DisclosureSelector'

interface Props<T extends FieldValues> {
  control: Control<T>
  name: Path<T>
  choices: WidgetBadgeChoice<string | number | boolean>[]
  disabled?: boolean
  size?: DisclosureSize
  fixed?: boolean
}

const FormDisclosureSelector = <T extends FieldValues>({
  control,
  name,
  choices,
  disabled,
  size = DisclosureSize.DEFAULT,
  fixed
}: Props<T>) => {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { value, onChange } }) =>
        fixed ? (
          <Badge
            badgeType={
              choices.find((choice) => choice.value === value)?.badgeType || BadgeType.DEFAULT
            }
          >
            {choices.find((choice) => choice.value === value)?.name || ''}
          </Badge>
        ) : (
          <DisclosureSelector
            value={value}
            name={name}
            choices={choices}
            onChange={onChange}
            disabled={disabled}
            size={size}
            remnant
          />
        )
      }
    />
  )
}

export default FormDisclosureSelector
